.tooltipContent {
  max-width: 18rem;
  padding: 1rem;
  color: white;
  font-size: 0.95rem;
  font-weight: 400;
  border-radius: 0.5rem;
  background-color: rgb(53, 53, 53);
}
